







































import Vue, { PropType } from "vue";
import log from "loglevel";

import { UpdateContractResponse } from "@/containers/contractAutoUpdateForm/api";

export interface ContractAutoUpdateFormProps {
  returnUrl: string;
  redirectUrl: string;
  errorUrl: string;
  updateText: string;
  cancelText: string;
  caption: string;
  contractNumber: string;
  updateContract: any;
  updateIsBusy: any;
}

export default Vue.extend({
  name: "vc-auto-update-contract-form",
  data: function() {
    return {
      radioValue: "autoUpdate", // チェックボックスの初期値
      isError: false,
      errorMessage: ""
    };
  },
  props: {
    returnUrl: {
      type: String as PropType<ContractAutoUpdateFormProps["returnUrl"]>,
      default: ""
    },
    redirectUrl: {
      type: String as PropType<ContractAutoUpdateFormProps["redirectUrl"]>,
      default: ""
    },
    errorUrl: {
      type: String as PropType<ContractAutoUpdateFormProps["errorUrl"]>,
      default: ""
    },
    updateText: {
      type: String as PropType<ContractAutoUpdateFormProps["updateText"]>,
      default: ""
    },
    cancelText: {
      type: String as PropType<ContractAutoUpdateFormProps["cancelText"]>,
      default: ""
    },
    caption: {
      type: String as PropType<ContractAutoUpdateFormProps["caption"]>,
      default: ""
    },
    contractNumber: {
      type: String as PropType<ContractAutoUpdateFormProps["contractNumber"]>,
      default: ""
    },
    //actionsToProps
    updateContract: {
      type: Function as PropType<ContractAutoUpdateFormProps["updateContract"]>,
      default: () => {}
    },

    //mutationsToProps
    updateIsBusy: {
      type: Function as PropType<ContractAutoUpdateFormProps["updateIsBusy"]>,
      default: () => {}
    }
  },

  methods: {
    async SendCancellationData() {
      this.updateIsBusy(true);
      const params = {
        contractNumber: this.contractNumber
      };
      try {
        const res: UpdateContractResponse = await this.updateContract(params);
        window.location.href = this.returnUrl;
      } catch (error) {
        log.error(error);
        alert(error);
        window.location.href = this.errorUrl + "?type=default_error";
        throw error;
      } finally {
        this.updateIsBusy(false);
      }
    }
  }
});
